module.exports = __webpack_public_path__ + "static/media/mapa-morado.ee31cfe7.png";